export default "__VITE_ASSET__DKbFc8Fu__"